import React from 'react'
import './loading.styles.scss'

const Loading = () => {
    return (
        <div className="loading"><div className="spinner"></div></div>
    )
}

export default Loading